module.exports = __webpack_public_path__ + "static/image_3-7fbbace26d764879304d0623459e51c4.jpg";